import { useEffect, useState } from "react";
import { Flex, LoadingIndicator, Text } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";
import { SPACING } from "~/styles/variables";
import * as styles from "./styles_vanilla.css";

// One caption line, alternating — the job reports no progress to drive a percentage or counter.
export const LOADING_CAPTIONS = ["Drafting answers...", "Checking the answer bank..."];

export const CAPTION_ROTATE_MS = 4000;

export const GenerationLoadingState = () => {
  const [captionIndex, setCaptionIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(
      () => setCaptionIndex((index) => (index + 1) % LOADING_CAPTIONS.length),
      CAPTION_ROTATE_MS,
    );
    return () => clearInterval(timer);
  }, []);

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={SPACING.MEDIUM}
      className={styles.loadingState}
      data-testid="ddq-generate-draft-loading"
    >
      <LoadingIndicator size="large" />
      <Text variant="regular-md" color={Colors.Neutral600} aria-live="polite">
        {LOADING_CAPTIONS[captionIndex]}
      </Text>
    </Flex>
  );
};
